(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HelpSearch', HelpSearch);

    HelpSearch.$inject = ['$resource'];

    function HelpSearch($resource) {
        var resourceUrl =  'api/_search/helps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
